import { render } from "./ProfilePane.vue?vue&type=template&id=38b7e6b5&scoped=true&ts=true"
import script from "./ProfilePane.vue?vue&type=script&lang=ts"
export * from "./ProfilePane.vue?vue&type=script&lang=ts"

import "./ProfilePane.vue?vue&type=style&index=0&id=38b7e6b5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b7e6b5"]])

export default __exports__